const loadEmployment = () => {
    const posts = Array.from(document.querySelectorAll('.job-post'))

    if (posts.length) {
        posts.forEach(post => {
            post.addEventListener('click', event => {
                const target = event.target
                if (target.classList.contains('job-read-more')) {
                    if (post.classList.contains('is-expanded')) {
                        target.innerHTML = 'Read more'
                    } else {
                        target.innerHTML = 'Read less'
                    }
                    post.classList.toggle('is-expanded')
                }
            })
        })
    }
}

export default loadEmployment



// WEBPACK FOOTER //
// ./js/employment.js